import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

const state = {
  // お知らせ配信管理の場合、true
  isBot: false,
  accessToken: null,
}

const getters = {
  get: state => state,
}

const actions = {
  init ({commit}, accessToken) {
    commit('inited', accessToken)
  },
  loadServiceInfo ({commit}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['noticeBot'],
        ['v1ServiceInfoGet'],
        [{
          accessToken: state.accessToken
        }])
        .then(res => {
          console.log(res)
          let status = Utility.parseResponse(res)

          if (status.result) {
            res[0].data.accessToken = state.accessToken
            this.dispatch('auth/setFromBot', res[0].data)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
}

const mutations = {
  inited (state, accessToken) {
    state.isBot = true
    state.accessToken = accessToken
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
